<template>
    <Layout>
        <PageHeader :title="title" :items="items" /> 
        <div class="row">
            <div class="col-lg-12 col-sm-12 mb-3">
                <div class="card p-4">
                    <div class="media">
                        <div class="avatar-sm mr-3">
                            <span class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22">
                                <i class="bx bx-world bx-md"></i>
                            </span>
                        </div>
                        <div class="media-body">
                            <h5 class="mt-3">{{ $t('website.website-info-search') }}</h5>
                        </div>
                    </div>
                    <div class="row mt-5 mb-3">
                        <div class="col-sm-12 text-right">
                            <div class="input-group">
                                <input
                                id="search"
                                type="text"
                                class="form-control"
                                v-model="searchKey"
                                placeholder="domainname.com"
                                aria-describedby="search"
                                v-on:input="removeHttp(searchKey)"
                                @keyup.enter="searchWebsite"
                                />
                                <div class="input-group-prepend">
                                <button
                                    id="search"
                                    class="input-group-text bg-primary text-white"
                                    @click="searchWebsite"
                                >
                                    <i class="bx bx-search-alt search-icon"></i>
                                </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="loading" class="row mt-5 mb-5 pb-4 mx-auto">
                        <div class="text-center">
                              <div class="spinner-border text-secondary" role="status" v-if="loading">
                            <span class="sr-only"><p>{{ $t('website.website-location') }}</p></span>
                          </div>
                        </div>
                    </div>
                    <div v-if="error !== '' && !loading" class="row mt-5 mb-5 pb-4 mx-auto">
                        <div class="text-center">
                           <span class="text-secondary">{{error}}</span>  
                        </div>
                    </div>


                    <div v-if="!SearchResult && !loading && search && error == ''" class="row mt-5 mb-5 pb-4 mx-auto">
                        <div class="text-center">
                           <span class="text-secondary">{{ $t('all.dnf') }}</span>  
                        </div>
                    </div>
                    <div>
                        <div class="row mt-1" v-if="SearchResult">
                          <!-- <p>
                            {{SearchResult}}
                          </p> -->
                            <div class="col-sm-12" >
                                  <p v-if="SearchResult.visitors"><b>{{ $t('website.visitors') }}: </b> {{SearchResult.visitors}}</p>
                                  <p v-if="SearchResult.ip_address"><b>{{ $t('website.ip') }}: </b> {{SearchResult.ip_address}}</p>
                                  <p v-if="SearchResult.link_ipv6_address"><b>{{ $t('website.link_ipv6_address') }}: </b> {{SearchResult.link_ipv6_address}}</p>
                                  <p v-if="SearchResult.ip_location"><b>{{ $t('website.ip_location') }}: </b> {{SearchResult.ip_location}}</p>
                                  <p v-if="SearchResult.ip_reverse_dns"><b>{{ $t('website.ip_reserve_dns') }}: </b> {{SearchResult.ip_reverse_dns}}</p>
                                  <p v-if="SearchResult.hosting_company"><b>{{ $t('website.hosting_company') }}: </b> {{SearchResult.hosting_company}}</p>
                                  <p v-if="SearchResult.hosting_ip_range"><b>{{ $t('website.hosting_ip_range') }}: </b> {{SearchResult.hosting_ip_range}}</p>
                                  <p v-if="SearchResult.hosting_address"><b>{{ $t('website.hosting_address') }}: </b> {{SearchResult.hosting_address}}</p>
                                  <p v-if="SearchResult.hosting_country"><b>{{ $t('website.hosting_country') }}: </b> {{SearchResult.hosting_country}}</p>
                                  <p v-if="SearchResult.hosting_phone"><b>{{ $t('website.hosting_phone') }}: </b> {{SearchResult.hosting_phone}}</p>
                                  <p v-if="SearchResult.cidr"><b>{{ $t('website.cidr') }}: </b> {{SearchResult.cidr}}</p>
                                  <p v-if="SearchResult.hosting_cidr"><b>{{ $t('website.hosting_cidr') }}: </b> {{SearchResult.hosting_cidr}}</p>
                                  =====================================================================================
                                  <div class="row mt-2 mx-0" v-if="SearchResultSubDomain">
                                  <b>Sub Domain: &nbsp;</b> 
                                  <span v-for="(sub, index) in SearchResultSubDomain" :key="index"> {{sub.subdomain}}, &nbsp;</span>
                                  </div>
                                   <div v-if="loadingsubdomain" class=" mt-4 mx-auto">
                                      <div class="text-center">
                                          <!-- <i class="bx bx-loader bx-lg bx-bx-world align-middle mr-2"></i>  -->
                                            <div class="spinner-border text-secondary" role="status" v-if="loadingsubdomain">
                                          <span class="sr-only"><p>{{ $t('website.website-info') }}</p></span>
                                        </div>
                                      </div>
                                  </div>
                            </div>
                               <div class="col-sm-12 text-right" v-if="SearchResult">
                                   <b-button class="btn" variant="secondary" size="sm" @click="clearData"><i class="fa fa-times"></i> {{ $t('website.clear') }}</b-button> <b-button class="btn" variant="success" size="sm" @click="saveWebsiteInfo"><i class="fa fa-check"></i> {{ $t('website.save') }}</b-button>
                              </div>
                        </div>
                    </div>
                   </div>
            </div>
        </div>

        <div class="row mt-5">
            <div class="col-sm-6">
                <h5>{{ $t('website.list_web_info') }}</h5>
            </div>
            <div class="col-sm-6 text-right">
            </div>
        </div>

        <div class="row mt-2 mb-4">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        {{ $t('all.show') }}&nbsp;&nbsp;
                        <b-form-select v-model="perPage" size="md" :options="pageOptions" class="mx-0"></b-form-select>&nbsp;&nbsp;{{ $t('all.entries') }} 
                      </label>
                    <b-button class="btn btn-sm ml-3" variant="danger" @click="bulkAction()" v-if="selected[0]">{{ $t('button.bulk') }}: {{selected.length}} {{ $t('button.row-data') }}</b-button>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                      <label class="d-inline-flex align-items-center">
                        {{ $t('all.search') }}:
                        <b-form-input
                          v-model="filter"
                          type="search"
                          :placeholder="$t('all.searchh')"
                          class="form-control form-control ml-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="table-responsive mb-0">
                  <b-table
                    :items="tableData"
                    :fields="fields"
                    striped bordered
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                  >
                  <template #head(bulk) width="4%">
                      <b-form-checkbox
                              v-model="selectAll" 
                              @change="select"
                              class="text-center mt-0">
                      </b-form-checkbox>
                  </template>
                  <template #cell(bulk)="row" width="4%">
                  <b-form-checkbox
                  class="text-center mt-0"
                      v-model="selected"
                      :value="row.item.id_web_info"
                    >
                  </b-form-checkbox>
                  </template>
                
                    <template #cell(actions)="row">
                        <router-link :to="{ name: 'website-info-detail', params: { id: row.item.id_web_info }}"><b-button class="mr-1 btn-sm mb-1" variant="secondary" >  <i class="bx bx-show-alt"></i></b-button></router-link>
                        <b-button class="btn-sm mb-1" variant="danger" @click="deleteWebsiteInfo(row.item.id_web_info)">
                        <i class="bx bx-trash"></i>
                        </b-button>
                    </template>
                  </b-table>

                  <div v-if="loadingInfo" class="mt-4 mx-auto p-5">
                      <div class="text-center">
                            <div class="spinner-border text-secondary" role="status" v-if="loadingInfo">
                          <span class="sr-only"><p>{{ $t('website.website-info') }}</p></span>
                        </div>
                      </div>
                  </div>
                </div>
               <div class="row" v-if="!loadingInfo && rows > 10">
                    <div class="col-2 col-xl-1">
                        <!-- <div v-if="selected[0]">
                        <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
                        </div> -->
                        <label class="d-inline-flex align-items-center">
                        Page
                        <b-form-input
                            v-model="currentPage"
                            placeholder="Page"
                            class="form-control w-10 form-control ml-2"
                        ></b-form-input>
                        </label>
                    </div>
                    <div class="col-10 col-xl-11 text-right" v-if="rows > 10">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                        <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                        </ul>
                    </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from 'moment';
import PhoneService from "@/helpers/phone.service.js";
import WebsiteService from "@/helpers/website.service.js";
import SocmedService from "@/helpers/socmed.service.js";
import Swal from "sweetalert2";

export default {
    page: {
        title: "Tools Website",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            urlimage: 'http://localhost:8001/api/target/image-project?name=',
            error: "",
            loading: false,
            loadingInfo: false,
            loadingsubdomain: false,
            search: false,
            searchKey: "",
            SearchResult: "",
            SearchResultSubDomain: "",
            total_results: "",
            tableData:[],
            selected:[],
            selectAll: false,
            dnf:false,
            dnfp:false,
            is_spam:"",
            search:false,
            title: this.$t('website.website-info'),
            items: [
                {
                text: "Dashboard",
                href: "/"
                },
                {
                text: this.$t('website.website-info'),
                active: true
                },
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: ['domain_name','visitors', 'ip_address', 'ip_location', 'hosting_company'],
            sortBy: "age",
            sortDesc: false,
            fields: [
                { key: "no",  class: 'text-center', thStyle: { width: "2%" }, label:'No'},
                { key: "bulk",  thStyle: { width: "2%" }, label:'#'},
                { key: "id_web_info", thClass: 'd-none', tdClass: 'd-none'},
                { key: "domain_name",  label: this.$t('website.domain_name'), sortable: true},
                { key: "visitors", label: this.$t('website.visitors'), sortable: true},
                { key: "ip_address", label: this.$t('website.ip_address')},
                { key: "ip_location", label: this.$t('website.ip_location'), sortable: true},
                { key: "hosting_company", label: this.$t('website.hosting_company'), sortable: true},
                { key: 'actions', class: 'text-center',   label: this.$t('website.actions')}
            ]
        }
    },
    computed: {
        rows() {
            return this.tableData.length;
        },
  },
  methods:{
        select() {
            // console.log('selected');
            this.selected = [];
            if (!this.selectAll) {
                for (let i in this.tableData) {
                    this.selected.push(this.tableData[i].id_web_info);
                }
            }
        },
        searchWebsite(){
          this.error = "",
          this.loading = true,
          this.search = true;
          this.SearchResult = "";
          // this.removeHttp(this.searchKey);
          const data = {
            "website": this.searchKey,
          }
          console.log('mulai', data);
          WebsiteService.searchWebInfo(data)
          .then(response => {
                    this.SearchResult = response.data.output;
                    this.loading = false;
                    this.searchWebsiteSubdomain();
                    // console.log(response.data.output);
                })
                .catch(err => {
                    console.log(err);
                    if( err.response.status == 500 ){
                      this.error = this.$t('all.error-500');
                    } else if( err.response.status == 404 ){
                      this.error = this.$t('all.error-404');
                    }
                    this.loading = false;
            });
        },

         searchWebsiteSubdomain(){
          this.loadingsubdomain = true,
          this.search = true;
          this.SearchResultSubDomain = "";
          const data = {
            "website": this.searchKey,
          }
          WebsiteService.searchSubDomain(data)
          .then(response => {
                    this.SearchResultSubDomain = response.data.output;
                    this.loadingsubdomain = false;
                })
                .catch(err => {
                    console.log(err);
                    this.loadingsubdomain = false;
            });
        },

          saveWebsiteInfo(){
          this.loadingsave = true;
          // console.log(this.SearchResult);
          var data = {
                  "domain_name": this.searchKey,
                  "visitors": this.SearchResult.visitors,
                  "ip_address": this.SearchResult.ip_address,
                  "link_ipv6_address": this.SearchResult.link_ipv6_address,
                  "ip_location": this.SearchResult.ip_location,
                  "ip_reverse_dns": this.SearchResult.ip_reverse_dns,
                  "hosting_company": this.SearchResult.hosting_company,
                  "hosting_ip_range": this.SearchResult.hosting_ip_range,
                  "hosting_address": this.SearchResult.hosting_address,
                  "hosting_country": this.SearchResult.hosting_country,
                  "hosting_phone": this.SearchResult.hosting_phone,
                  "hosting_website": this.SearchResult.hosting_website,
                  "cidr": this.SearchResult.cidr,
                  "hosting_cidr": this.SearchResult.hosting_cidr,          
                  }
                  // console.log(data);
          WebsiteService.createWebInfo(data)
          .then(response => {
                    this.SearchResult ="";
                    this.searchKey = "";
                    this.loading = false;  
                    this.search = false;
                    Swal.fire(response.data.message, '', 'success') 
                    this.getWebsiteInfoUpdate();
                    this.saveSubdomain(response.data.data.id_web_info);
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
            });
        },

          saveSubdomain(id){
          var data = {
                "id_web_info": id,
                "subdomain":  JSON.stringify(this.SearchResultSubDomain),
          }
        //   console.log(data);
          WebsiteService.createSubDomain(data)
          .then(response => {
                    this.SearchResultSubDomain = "";
                    this.searchKey = "";
                    this.loading = false;
                    this.search = false;
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
                    this.search = false;
            });
        },

        getWebsiteInfo(){
          this.loadingInfo = true;
          WebsiteService.getWebInfo()
          .then(response => {
                    this.tableData = [];
                    this.total_results = response.data.data.length;

                     response.data.data.forEach((val, index) => {
                        const data = {
                          no: index+1,
                          id_web_info: val.id_web_info,
                          domain_name: val.domain_name,
                          id_package: val.id_package,  
                          visitors: val.visitors,
                          ip_address: val.ip_address,  
                          link_ipv6_address: val.link_ipv6_address,
                          ip_location: val.ip_location,  
                          ip_reverse_dns: val.ip_reverse_dns,  
                          hosting_company: val.hosting_company,
                          hosting_ip_range: val.hosting_ip_range,  
                          hosting_address: val.hosting_address,  
                          cidr: val.cidr,
                          hosting_cidr: val.hosting_cidr,  

                          created_at: this.formatDate(val.created_at),
                          updated_at: this.formatDate(val.updated_at),
                        };
                        this.tableData.push(data);
                     })
                    this.loadingInfo = false;
                })
                .catch(err => {
                    console.log(err);
                    this.loadingInfo = false;
            });
        },

          getWebsiteInfoUpdate(){
          WebsiteService.getWebInfo()
          .then(response => {
                    this.tableData = [];
                    this.total_results = response.data.data.length;

                     response.data.data.forEach((val, index) => {
                        const data = {
                          no: index+1,
                          id_web_info: val.id_web_info,
                          domain_name: val.domain_name,
                          id_package: val.id_package,  
                          visitors: val.visitors,
                          ip_address: val.ip_address,  
                          link_ipv6_address: val.link_ipv6_address,
                          ip_location: val.ip_location,  
                          ip_reverse_dns: val.ip_reverse_dns,  
                          hosting_company: val.hosting_company,
                          hosting_ip_range: val.hosting_ip_range,  
                          hosting_address: val.hosting_address,  
                          cidr: val.cidr,
                          hosting_cidr: val.hosting_cidr,  

                          created_at: this.formatDate(val.created_at),
                          updated_at: this.formatDate(val.updated_at),
                        };
                        this.tableData.push(data);
                     })
                    this.loadingInfo = false;
                })
                .catch(err => {
                    console.log(err);
                    this.loadingInfo = false;
            });
        },
         deleteWebsiteInfo(id){
           Swal.fire({
                  title: this.$t('button.delete.modal.confirmText[0]'),
                  text: this.$t('button.delete.modal.confirmText[1]'),
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#34c38f",
                  cancelButtonColor: "#f46a6a",
                  cancelButtonText: this.$t('button.cancel.text'),
                  confirmButtonText: this.$t('button.delete.text')
              }).then((result) => {
                  if (result.isConfirmed) {
                      WebsiteService.deleteWebInfo(id)
                      .then( response => {
                          this.getWebsiteInfo();
                          Swal.fire({
                              position: "top-end",
                              icon: "success",
                              title: "Data Deleted Success",
                              showConfirmButton: false,
                              timer: 1500
                          });
                      })
                      .catch( err => {
                          console.log(err);
                      });
                  }
              });
        },
        bulkAction(){
             Swal.fire({
                  title: this.$t('button.delete.modal.confirmText[0]'),
                  text: this.$t('button.delete.modal.confirmText[1]'),
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#34c38f",
                  cancelButtonColor: "#f46a6a",
                  cancelButtonText: this.$t('button.cancel.text'),
                  confirmButtonText: this.$t('button.delete.text')
              }).then((result) => {
                  if (result.isConfirmed) {
                    var data = this.selected;
                      WebsiteService.websiteBulkWebInfo(data)
                      .then( response => {
                         this.selected = [];
                          this.getWebsiteInfo();
                          Swal.fire({
                              position: "top-end",
                              icon: "success",
                              title: this.$t('alert.alert-delete-web'),
                              showConfirmButton: false,
                              timer: 1500
                          });
                      })
                      .catch( err => {
                          console.log(err);
                      });
                  }
              });
        },
        clearData(){
          this.SearchResult = "";
          this.searchKey = "";
          this.search = false;
        },
        removeHttp(url){
          let x = url.replace(/(^\w+:|^)\/\//, '').replace("/", "").replace('www.', '');
          return this.searchKey = x;
        },
        
      formatDate(value){
          return moment(value).format("dddd, YYYY-MM-DD hh:mm");
      },
  },
    mounted(){
        this.totalRows = this.items.length;
        this.getWebsiteInfo();
    }
};
</script>

<style scoped>
.loading{
    padding-top:20%;
    padding-bottom:20%;
}
</style>